var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"action-bar-delete\" style=\"overflow: auto; width: auto; height: auto;\" class=\"popup popup-delete\"><div ng-style=\"{'background': theme_color}\" class=\"head\"><h2>Delete Application{{bundles.length === 1 ? '' : 's'}}</h2><a title=\"Close\" href=\"#\" ng-click=\"$dismiss()\" class=\"fancybox-item fancybox-close\"></a></div><div class=\"container\"><p>Are you sure you want to delete {{bundles.length === 1 ? 'this application' : 'these applications'}}?</p><div class=\"buttons\"><a ng-click=\"$dismiss()\" class=\"cancel view-delete-button\">Cancel</a><a ng-click=\"remove_apps()\" class=\"delete delete-item-button\">Delete</a><div class=\"cf\"></div></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/applicationDeleteModal/applicationDeleteModal.jade
// module id = 541
// module chunks = 0